var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4H11C6.757 4 4.636 4 3.318 5.318C2 6.636 2 8.758 2 13C2 17.242 2 19.364 3.318 20.682C4.636 22 6.758 22 11 22C15.242 22 17.364 22 18.682 20.682C20 19.364 20 17.242 20 13V10.5M6 8L16 18M6 14L10 18M12 8L16 12M19.5 2.938V4.5M19.5 4.5V6.063M19.5 4.5H18.25M19.5 4.5H20.75M22 4.5L20.916 4.139C20.6704 4.05698 20.4472 3.91896 20.2641 3.73587C20.081 3.55277 19.943 3.3296 19.861 3.084L19.5 2L19.139 3.084C19.057 3.3296 18.919 3.55277 18.7359 3.73587C18.5528 3.91896 18.3296 4.05698 18.084 4.139L17 4.5L18.084 4.861C18.582 5.027 18.973 5.418 19.139 5.916L19.5 7L19.861 5.916C19.943 5.6704 20.081 5.44723 20.2641 5.26413C20.4472 5.08104 20.6704 4.94302 20.916 4.861L22 4.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIcon);
export default __webpack_public_path__ + "static/media/common-icon.fb595898d021e4ae1aa0c22a5ddb887d.svg";
export { ForwardRef as ReactComponent };